'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Mixins$FormBuilder = require("./Mixins.bs.js");
var Palette$FormBuilder = require("./Palette.bs.js");

var formContainer = Curry._1(Css.merge, {
      hd: Mixins$FormBuilder.flex_col_between_center,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.position("relative"),
              tl: {
                hd: Css.width({
                      NAME: "vw",
                      VAL: 40
                    }),
                tl: {
                  hd: Css.height({
                        NAME: "vh",
                        VAL: 100
                      }),
                  tl: {
                    hd: Css.flexGrow(0),
                    tl: {
                      hd: Css.background({
                            NAME: "hex",
                            VAL: Palette$FormBuilder.bgSecondary
                          }),
                      tl: {
                        hd: Css.media("(max-width: 780px)", {
                              hd: Css.width({
                                    NAME: "percent",
                                    VAL: 100
                                  }),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var form = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100
          }),
      tl: {
        hd: Css.height({
              NAME: "percent",
              VAL: 100
            }),
        tl: {
          hd: Css.overflow("auto"),
          tl: {
            hd: Css.padding2({
                  NAME: "rem",
                  VAL: 0.8
                }, Css.rem(1)),
            tl: /* [] */0
          }
        }
      }
    });

var inputContainer = Curry._1(Css.merge, {
      hd: Mixins$FormBuilder.flex_start_center,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.padding2({
                    NAME: "rem",
                    VAL: 3
                  }, {
                    NAME: "rem",
                    VAL: 1
                  }),
              tl: {
                hd: Css.borderBottom({
                      NAME: "px",
                      VAL: 1
                    }, "dashed", {
                      NAME: "hex",
                      VAL: "ddd"
                    }),
                tl: {
                  hd: Css.selector("&:last-child", {
                        hd: Css.borderBottom({
                              NAME: "px",
                              VAL: 0
                            }, "none", Css.transparent),
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }
            }),
        tl: /* [] */0
      }
    });

var inputEntry = Curry._1(Css.keyframes, {
      hd: [
        0,
        {
          hd: Css.opacity(0.0),
          tl: {
            hd: Css.transform(Css.scale3d(0.5, 0.5, 0.5)),
            tl: /* [] */0
          }
        }
      ],
      tl: {
        hd: [
          100,
          {
            hd: Css.opacity(1.0),
            tl: {
              hd: Css.transform(Css.scale3d(1, 1, 1)),
              tl: /* [] */0
            }
          }
        ],
        tl: /* [] */0
      }
    });

var input = Curry._1(Css.style, {
      hd: Css.animationName(inputEntry),
      tl: {
        hd: Css.animationDuration(500),
        tl: {
          hd: Css.animationTimingFunction(Css.cubicBezier(0.16, 1, 0.3, 1)),
          tl: {
            hd: Css.transformOrigin({
                  NAME: "percent",
                  VAL: 10.0
                }, Css.px(0)),
            tl: {
              hd: Css.padding2({
                    NAME: "rem",
                    VAL: 1
                  }, {
                    NAME: "rem",
                    VAL: 1
                  }),
              tl: {
                hd: Css.width({
                      NAME: "percent",
                      VAL: 100
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var formButtonsContainer = Curry._1(Css.style, {
      hd: Css.position("absolute"),
      tl: {
        hd: Css.bottom("zero"),
        tl: /* [] */0
      }
    });

var buttonContainer = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100
          }),
      tl: {
        hd: Css.padding2(Css.em(1), Css.em(2)),
        tl: {
          hd: Css.borderTop({
                NAME: "px",
                VAL: 2
              }, "solid", Css.lightgray),
          tl: {
            hd: Css.margin2({
                  NAME: "rem",
                  VAL: 1
                }, {
                  NAME: "rem",
                  VAL: 1
                }),
            tl: /* [] */0
          }
        }
      }
    });

var form_buttons_c_height = 50;

exports.form_buttons_c_height = form_buttons_c_height;
exports.formContainer = formContainer;
exports.form = form;
exports.inputContainer = inputContainer;
exports.inputEntry = inputEntry;
exports.input = input;
exports.formButtonsContainer = formButtonsContainer;
exports.buttonContainer = buttonContainer;
/* formContainer Not a pure module */
